type UpsellSource = "checkout" | "onsite" | "postPurchase";

const shouldRenderUpsellColumn =
  (upsellSource: UpsellSource) =>
  (params: { upsellSource?: UpsellSource; variantSelection?: string }) =>
    params.upsellSource === upsellSource;

export const columnConfig = [
  {
    key: "product_title",
    label: "Product Title",
    rowGroup: true,
    dataFormat: "noFormatting",
  },
  {
    key: "variant_title",
    label: "Variant Title",
    rowGroup: true,
    dataFormat: "noFormatting",
    pinned: "left",
    renderRule: (params: { variantSelection?: string }) => {
      return params.variantSelection === "include_variants";
    },
  },
  {
    key: "variation_id",
    label: "Test Group",
    rowGroup: false,
    dataFormat: "noFormatting",
    defaultWidth: 250,
  },
  {
    key: "n_orders",
    label: "Total Orders",
    rowGroup: false,
    dataFormat: "numberNoDecimal",
  },
  {
    key: "n_orders_from_checkout_upsell",
    label: "Total Upsell Orders",
    rowGroup: false,
    dataFormat: "numberNoDecimal",
    renderRule: shouldRenderUpsellColumn("checkout"),
  },
  {
    key: "n_orders_from_onsite_upsell",
    label: "Total Upsell Orders",
    rowGroup: false,
    dataFormat: "numberNoDecimal",
    renderRule: shouldRenderUpsellColumn("onsite"),
  },
  {
    key: "n_orders_from_post_purchase_offer",
    label: "Total Upsell Orders",
    rowGroup: false,
    dataFormat: "numberNoDecimal",
    renderRule: shouldRenderUpsellColumn("postPurchase"),
  },
  {
    key: "orders_per_visitor",
    label: "Orders per visitor",
    rowGroup: false,
    dataFormat: "numberNoRounding",
  },
  {
    key: "pct_orders",
    label: "% of Orders",
    rowGroup: false,
    dataFormat: "percentTwoDecimal",
  },
  {
    key: "unit_quantity",
    label: "Unit Quantity",
    rowGroup: false,
    dataFormat: "numberNoDecimal",
  },
  {
    key: "unit_quantity_from_checkout_upsell",
    label: "Unit Quantity from Upsell",
    rowGroup: false,
    dataFormat: "numberNoDecimal",
    renderRule: shouldRenderUpsellColumn("checkout"),
  },
  {
    key: "unit_quantity_from_onsite_upsell",
    label: "Unit Quantity from Upsell",
    rowGroup: false,
    dataFormat: "numberNoDecimal",
    renderRule: shouldRenderUpsellColumn("onsite"),
  },
  {
    key: "unit_quantity_from_post_purchase_offer",
    label: "Unit Quantity from Upsell",
    rowGroup: false,
    dataFormat: "numberNoDecimal",
    renderRule: shouldRenderUpsellColumn("postPurchase"),
  },
  {
    key: "units_per_visitor",
    label: "Units Per Visitor",
    rowGroup: false,
    dataFormat: "numberNoRounding",
  },
  {
    key: "atc_rate",
    label: "Add to Cart Rate",
    rowGroup: false,
    dataFormat: "percentTwoDecimal",
  },
  {
    key: "net_product_revenue",
    label: "Net Product Revenue",
    rowGroup: false,
    dataFormat: "currency",
  },
  {
    key: "net_product_revenue_per_visitor",
    label: "Net Product Revenue/Visitor",
    rowGroup: false,
    dataFormat: "currency",
  },
  {
    key: "net_product_revenue_from_checkout_upsell",
    label: "Net Product Revenue from Upsell",
    rowGroup: false,
    dataFormat: "currency",
    renderRule: shouldRenderUpsellColumn("checkout"),
  },
  {
    key: "net_product_revenue_from_onsite_upsell",
    label: "Net Product Revenue from Upsell",
    rowGroup: false,
    dataFormat: "currency",
    renderRule: shouldRenderUpsellColumn("onsite"),
  },
  {
    key: "net_product_revenue_from_post_purchase_offer",
    label: "Net Product Revenue from Upsell",
    rowGroup: false,
    dataFormat: "currency",
    renderRule: shouldRenderUpsellColumn("postPurchase"),
  },
  {
    key: "gross_product_profit",
    label: "Gross Product Profit",
    rowGroup: false,
    dataFormat: "currency",
  },
  {
    key: "gross_product_profit_from_checkout_upsell",
    label: "Gross Product Profit from Upsell",
    rowGroup: false,
    dataFormat: "currency",
    renderRule: shouldRenderUpsellColumn("checkout"),
  },
  {
    key: "gross_product_profit_from_onsite_upsell",
    label: "Gross Product Profit from Upsell",
    rowGroup: false,
    dataFormat: "currency",
    renderRule: shouldRenderUpsellColumn("onsite"),
  },
  {
    key: "gross_product_profit_from_post_purchase_offer",
    label: "Gross Product Profit from Upsell",
    rowGroup: false,
    dataFormat: "currency",
    renderRule: shouldRenderUpsellColumn("postPurchase"),
  },
  {
    key: "gross_profit_per_visitor",
    label: "Gross Profit/Visitor",
    rowGroup: false,
    dataFormat: "currency",
  },
];
